import React, { useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { StyledMember, StyledPanel } from '../stylesheets/styles';
import { API_URL } from '../common/constants';
import AuthContext from '../contexts/AuthContext';
import { useContext } from 'react';
import BgComponent from '../components/BgComponent';
import classNames from 'classnames';

const Login = () => {
  const { 
      register, 
      handleSubmit, 
      watch,
      setError, 
      formState: { errors, isSubmitting }
    } = useForm({
      defaultValues: {
        Account: '',
        Password: ''
      }
    }
  );
  const { isAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuth) {
      navigate('/');
    }
  }, [isAuth, navigate]);

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`${API_URL}/api/member/login`, data);
      const { isSuccess, message, result } = response.data;

      setError("root", {
        message: message,
        isSuccess: isSuccess,
      });
      if (isSuccess) {
        const token = result.token;
        localStorage.setItem("token", token);
        navigate("/");
      } else {
        setError("root", {
          message: message,
        });
      }

    } catch (error) {
      if (error.response && error.response.data) {
        setError("root", {
          type: "manual",
          message: error.response.data.message || '登入失敗，請稍後再試'
        });
      } else {
        setError("root", {
          type: "manual",
          message: '登入失敗，請稍後再試'
        });
      }
    }
  };
  
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">登入</h1>
                </div>
                <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group mb-3">
                    <label htmlFor="Account" className="form-label">信箱/手機門號</label>
                    <input {...register("Account")} type="Account" placeholder='信箱/手機門號' className="form-control" id="Email" />
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="Password" className="form-label">密碼</label>
                    <input {...register("Password")} type="Password" placeholder='請輸入登入密碼' className="form-control" id="Password" />
                  </div>
                  <div className="form-button pt-4">
                    <Button disabled={isSubmitting} size="lg" variant="dark" className="w-100" type="submit">
                      { isSubmitting ? '處理中...' : '登入' }
                    </Button>
                    {errors.root && <p className={classNames("form-helper text-center mt-2", errors.root.isSuccess ? 'text-success' : 'text-danger')}>{errors.root.message}</p>}
                    <div className="d-flex align-items-center justify-content-between pt-3">
                      <Link to="/forgetpwd" className="btn btn-link p-0">忘記密碼</Link>
                      <Link to="/register" className="btn btn-link p-0">註冊新會員</Link>
                    </div>
                  </div>
                </Form>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

export default Login;